import PersonIcon from '@mui/icons-material/Person';
import { Avatar, styled } from '@mui/material';
import React from 'react';
import { WsColors } from 'wisestep-base';

interface WsAvatarProps {
  src?: string;
  name?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  active?: boolean;
  variant?: 'circular' | 'rounded' | 'square';
  children?: React.ReactNode;
}

enum AvatarSize {
  xsmall = 24,
  small = 32,
  medium = 40,
  large = 48,
}

enum AvatarVariant {
  circular = '50%',
  rounded = '6px',
}

const StyledAvatar = styled(Avatar)(
  ({ active, size, variant }: { active?: boolean; size: number; variant: string }) => ({
    border: `2px solid ${active ? WsColors.TheBlues500 : WsColors.Neutral300}`,
    color: 'white',
    background: `linear-gradient(45deg, ${
      active ? WsColors.TheBlues500 : WsColors.Neutral300
    } 50%, ${active ? WsColors.TheBlues600 : WsColors.Neutral500} 50%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size,
    borderRadius: AvatarVariant[variant],
  })
);

const WsAvatar: React.FC<WsAvatarProps> = ({
  src,
  name,
  size = 'small',
  active = true,
  variant = 'circular',
  children,
}) => {
  return (
    <StyledAvatar src={src} alt={name} variant={variant} size={AvatarSize[size]} active={active}>
      {children ?? (!src && <PersonIcon fontSize="inherit" />)}
    </StyledAvatar>
  );
};

export default WsAvatar;
